import { createContext, type ReactNode, useContext } from "react";
import type { StorefrontShellProps } from "~/app/shell/types";

const StorefrontShellPropsContext = createContext<StorefrontShellProps | undefined>(undefined);

export function StorefrontShellPropsProvider({
  value,
  children,
}: {
  value: StorefrontShellProps;
  children: ReactNode;
}) {
  return <StorefrontShellPropsContext.Provider value={value}>{children}</StorefrontShellPropsContext.Provider>;
}

export function useStorefrontShellProps() {
  const props = useContext(StorefrontShellPropsContext);

  if (!props) {
    throw new Error("StorefrontShell route rendered without StorefrontShell props.");
  }

  return props;
}
